<template>
  <section
    v-if="isEnglish"
    class="mt-20 border-t border-black/10 px-4 pb-16 pt-10 text-[#15120f] sm:px-0 lg:pb-20"
    aria-labelledby="french-heels-seo-band-title"
  >
    <div class="mx-auto grid max-w-5xl gap-6 md:grid-cols-[minmax(0,0.7fr)_minmax(0,0.3fr)] md:items-end">
      <div>
        <p class="text-[0.62rem] uppercase tracking-[0.32em] text-black/38">French heels</p>
        <h2 id="french-heels-seo-band-title" class="mt-3 font-['Playfair_Display'] text-[2.25rem] leading-[0.95] tracking-[0] text-black sm:text-[3.1rem]">
          Parisian designer heels, made in Italy.
        </h2>
        <p class="mt-5 max-w-2xl text-[0.98rem] leading-[1.8] text-black/68">
          Compare Kendrick pumps, ankle boots, boots and sandals through the lens of French heel
          design: proportion, balance, material quality and walking stability.
        </p>
      </div>

      <NuxtLink
        to="/french-heels"
        class="inline-flex w-fit items-center border-b border-black/22 pb-1 text-[0.62rem] uppercase tracking-[0.32em] text-black transition hover:border-black/50"
      >
        French heels guide
      </NuxtLink>
    </div>
  </section>
</template>

<script setup lang="ts">
const siteLocale = useSiteLocale()
const isEnglish = computed(() => siteLocale.value === 'en')
</script>
